import { render, staticRenderFns } from "./VideoSelectorModal.vue?vue&type=template&id=c7e473c2&"
import script from "./VideoSelectorModal.vue?vue&type=script&lang=js&"
export * from "./VideoSelectorModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoSelectorModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports